import useMapBoxSearch from './use-mapbox-search';

export default useMapBoxSearch;